import Udesk from 'Udesk';
import SemanticTagsDetailComponent from './component';
// import _isEmpty from 'lodash-es/isEmpty';
import _filter from 'lodash-es/filter';
// import _find from 'lodash-es/find';
import _size from 'lodash-es/size';
import { LanguageEnum } from 'Component/pages/components/LanguageSelect/const';
class SemanticTagsDetailRoute extends SemanticTagsDetailComponent {
    asyncModel() {
        let { match, sdkOptions } = this.props;
        let listmap = {};

        if (match.params.id) {
            let url1 = Udesk.business.apiPath.concatApiPath(
                `semantic-tag/${match.params.id}`,
                sdkOptions
            );
            listmap = new Promise((resolve, reject) => {
                Udesk.ajax.get(url1).then(
                    (resp) => {
                        resolve(resp);
                    },
                    (reason) => {
                        Udesk.ui.notify.error(reason.errorMsg);
                        reject(reason);
                    }
                );
            });
            // .then(dataList => {
            //     let data = {
            //         tagId: null,
            //         searchMinScore: 60,
            //         searchMaxScore: 80,
            //         pageNum: 1,
            //         pageSize: 10
            //     };
            //     if (dataList && !_isEmpty(dataList.tags)) {
            //         let field = _find(
            //             dataList.tags,
            //             current => current.standardFlag === 1
            //         );
            //         data.tagId = field.id;
            //         this.privates.tagId = data.tagId;
            //     }
            //     //训练查询
            //     let url4 = Udesk.business.apiPath.concatApiPath(
            //         `semantic-tag/similar-sentences`,
            //         sdkOptions
            //     );
            //     return new Promise((resolve, reject) => {
            //         Udesk.ajax.post(url4, data).then(
            //             resp => {
            //                 resolve({
            //                     listmap: dataList,
            //                     trainList: resp.data
            //                 });
            //                 if (resp.paging && resp.data) {
            //                     this.privates.paging.pageNum = resp.paging.pageNum + 1;
            //                 }
            //             },
            //             reason => {
            //                 Udesk.ui.notify.error(reason.errorMsg);
            //                 reject(reason);
            //             }
            //         );
            //     });
            // });
        } else {
            listmap = new Promise((resolve, reject) => {
                resolve({
                    data: {
                        tags: [],
                        recallWords: [],
                        excludeKeyword: [],
                    },
                });
            });
        }
        let url2 = Udesk.business.apiPath.concatApiPath(`semantic-tag/rule-field`, sdkOptions);
        let ruleField = new Promise((resolve, reject) => {
            Udesk.ajax.get(url2).then(
                (resp) => {
                    resolve(resp.data);
                },
                (reason) => {
                    Udesk.ui.notify.error(reason.errorMsg);
                    reject(reason);
                }
            );
        });
        return {
            listmap,
            ruleField,
        };
    }

    parseAsyncModel(asyncModel, { asyncKey }) {
        return asyncModel;
    }
    onAsyncModelResolved(asyncModel, parseOptions) {
        let { asyncKey, asyncResult } = parseOptions;
        if (asyncKey === 'listmap' && asyncResult.data) {
            this.privates.id = asyncResult.data.id;
            this.privates.title = asyncResult.data.title ?? '';
            this.privates.effectiveness =
                asyncResult.data.activeFlag ?? Udesk.enums.activeFlags.effiective.id;
            this.privates.standardSentences = asyncResult.data.standardContent ?? '';
            this.privates.type = asyncResult.data.type ?? null;
            this.privates.editEnable = asyncResult.data.editEnable;
            this.privates.lang = asyncResult.data.lang ?? LanguageEnum.ZH;

            this.actions.getInformationEntity();
            this.actions.getConceptWord();

            if (asyncResult.data.tags && asyncResult.data.tags.length > 0) {
                this.privates.similaSentences = asyncResult.data.tags.map((item, index) => {
                    return {
                        ...item,
                        order: index,
                    };
                });
                this.privates.similaSentencesCount = _size(this.privates.similaSentences) + 1;
            } else {
                this.privates.similaSentences = [];
                this.privates.similaSentencesCount = 0;
            }
            if (asyncResult.data.recallWords) {
                this.privates.recallKeyWord = asyncResult.data.recallWords.map((item, index) => {
                    return {
                        id: index,
                        text: item,
                    };
                });
                this.privates.recallKeyWordCount = _size(asyncResult.data.recallWords);
            }
            if (asyncResult.data.excludeKeyword) {
                this.privates.excludeKeyword = asyncResult.data.excludeKeyword.map(
                    (item, index) => {
                        return {
                            id: index,
                            text: item,
                        };
                    }
                );
                this.privates.excludeKeywordCount = _size(asyncResult.data.excludeKeyword);
            }
            if (asyncResult.data.customRules && asyncResult.data.customRules.length > 0) {
                this.privates.customRules = _filter(
                    asyncResult.data.customRules,
                    (current) => current.fieldType !== 'fe'
                ).map((item, index) => {
                    return {
                        ...item,
                        id: `customRules_${index}`,
                        name: item.label ? item.label : item.keyWords ? item.keyWords : null,
                    };
                });
                this.privates.customRules = [
                    ...this.privates.customRules,
                    {
                        id: 'none',
                    },
                ];
                this.privates.rulelistValue = this.privates.customRules;
            } else {
                this.privates.rulelistValue = [];
                this.privates.customRules = [{ id: 'none' }];
            }
            if (asyncResult.data.recallRegularList) {
                this.privates.recallRegularList = asyncResult.data.recallRegularList.map(
                    (item, index) => {
                        return {
                            id: index,
                            text: item,
                        };
                    }
                );
                this.privates.recallRegularListCount = _size(asyncResult.data.recallRegularList);
            }
            if (asyncResult.data.excludeRegularList) {
                this.privates.excludeRegularList = asyncResult.data.excludeRegularList.map(
                    (item, index) => {
                        return {
                            id: index,
                            text: item,
                        };
                    }
                );
                this.privates.excludeRegularListCount = _size(asyncResult.data.excludeRegularList);
            }
            if (asyncResult.data.highLevelConfig) {
                this.privates.highLevelConfig = {
                    ...asyncResult.data.highLevelConfig,
                    similarSentenceAutoExtend: {
                        enabledAi:
                            (asyncResult.data.highLevelConfig.similarSentenceAutoExtend ?? {}).enabledAi ===
                            1,
                        enabledNlp:
                            (asyncResult.data.highLevelConfig.similarSentenceAutoExtend ?? {})
                                .enabledNlp === 1,
                    },
                };
            } else {
                this.privates.highLevelConfig = {
                    crossSentence: {
                        on: 0,
                        crossLength: 1,
                        differentRoleLength: 0,
                        maxCrossLength: 100,
                    },
                    duplicate: {
                        on: 0,
                        threshold: 80,
                    },
                    similarityDegreeThreshold: {
                        threshold: 80,
                    },
                    similarSentenceAutoExtend: {
                        enabledAi: false,
                        enabledNlp: false,
                    },
                };
            }
            // if (asyncResult.trainList) {
            //     this.privates.transList = asyncResult.trainList;
            // }
            this.actions.update();
            this.props.form.resetFields();
        } else if (asyncKey === 'ruleField') {
            let list1 = _filter(asyncResult, (current) => current.fieldType !== 'fe');
            let list2 = _filter(asyncResult, (current) => current.fieldType === 'fe');
            this.privates.ruleFields = list1.map((item, index) => {
                return {
                    ...item,
                    id: `ruleFields_${index}`,
                };
            });
            this.privates.ruleFieldsStartEnd = list2;
            this.actions.update();
        }
    }
}

export default SemanticTagsDetailRoute;
